module.exports = __webpack_public_path__ + "static/media/08.0373e94b.jpg";